//getUserWoAssTask
import _axios from '../../../util/axios/AxiosConfig'

export function getDetail(key){
    return _axios({
        url: `/api/AbsoluteReceive/getDetail?supplyId=${key}`,
        method: 'get'
    })
}

export function submit(data){
    return _axios({
        url: `/api/AbsoluteReceive/submit`,
        method: 'post',
        data:data
    })
}
